import { render, staticRenderFns } from "./button-bubble-tl.vue?vue&type=template&id=0ece4ff4&scoped=true&"
var script = {}
import style0 from "./button-bubble-tl.vue?vue&type=style&index=0&id=0ece4ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ece4ff4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ece4ff4')) {
      api.createRecord('0ece4ff4', component.options)
    } else {
      api.reload('0ece4ff4', component.options)
    }
    module.hot.accept("./button-bubble-tl.vue?vue&type=template&id=0ece4ff4&scoped=true&", function () {
      api.rerender('0ece4ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/button-bubble-tl.vue"
export default component.exports